import { Box, Divider, IconButton, Modal, Paper, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown, Image } from 'react-bootstrap'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** ASSEST */
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import AppointmentApi, { AppointmentInterface, AppointmentOperativeInterface } from 'api/counter/appointment.api'
import ComponentApi from 'api/components-api'
import iconTime from 'assets/icon/appointment/card/ap-card-clock.svg'
import phone from 'assets/icon/appointment/card/ap-card-phone.svg'
import ClosePopup from 'assets/icon/appointment/close'
import print from 'assets/icon/carlendar/print.svg'
import iconEdit from 'assets/icon/iconEdit.svg'
import IconEllipsis from 'assets/icon/iconEllipsis'
import IconStar from 'assets/icon/IconStar'
import { Icons } from 'constants/images'
import { scale } from 'constants/scale'
import { colors, ThemeIcon } from 'constants/theme'
import _ from 'lodash'
import { routeName } from 'routes/routes-name'
import { numberFormat } from 'utils/app.utils'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import Collapse from '@mui/material/Collapse'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import AboutUs from 'api/admin/clinic-manage/about.api'
import { selectMe } from 'app/slice/user.slice'
import { formAppointment } from 'app/slice/appointment.slice'
import FunctionPrint from 'component/Print/print'
import { useSelector } from 'react-redux'
import { dateTimeToView } from 'utils/date.utils'
import UseWindowSize from 'utils/useWindowSize'
import { isCreate, isDelete, isExport, isUpdate, isView } from 'utils/verification.utils'

import PDFA5EN from 'component/Pdf/PdfA5EN'
import PDFA5TH from 'component/Pdf/PdfA5TH'
import PDFThermalEN from 'component/Pdf/PdfThermalEN'
import PDFThermalTH from 'component/Pdf/PdfThermalTH'
import { exportOPDAppointment } from 'component/Print/exportPdf'




type FixPositionType = {
  top: string
  left?: string
}

type CardSchedule = {
  showPopup: boolean
  hideMenu?: boolean | false
  appointmentId: number
  color?: string
  fixPosition?: FixPositionType
  timeStart?: string
  timeEnd?: string
  status?: string
  branch: any
  onEdit?: (id: number) => void
  onEditSpecialInfo?: (id: number) => void
  onEditFeedback?: (id: number) => void
  onClose?: (id: number) => void
  onClick?: (event: any) => void
  onLoading?: (event: boolean) => void
  key?: any
  isNotShowPhoneNumber?: boolean
  popAutoScroll?: boolean
  width?: any
  displayType?: string
}


const CardViewDetail = styled('div')<{ fixPosition?: FixPositionType; transform: number; dropDown: boolean; appointment?: AppointmentInterface; statusColor: string, positioncard: 'top' | 'bottom', position: 'fixed' | 'absolute', transformx: number, width?: any, displayType?: string }>(({ theme, fixPosition, transform, dropDown, appointment, statusColor, positioncard, position, transformx, width, displayType }) => ({
  position: position,
  zIndex: 200,
  top: displayType === 'month' ? fixPosition?.top : `calc(${'2rem'} + ${transform}px)`,
  left: transformx ? `${transformx}px` : fixPosition?.left || '2rem',
  display: dropDown && appointment?.timeStart !== undefined ? 'block' : 'none',
  padding: '40px 15px 15px',
  width: width === 500 ? '350px' : '284px',
  height: 'auto',
  // maxHeight: 'calc(100vh - 300px)',
  backgroundColor: colors.white80,
  boxShadow: `0px 4px 5px ${colors.black10}`,
  // transform: 'translate3d(8px, 0px, 0px)',
  borderTop: '10px',
  border: `1px solid ${colors.borderHeaderCard}`,
  opacity: '1',
  backdropFilter: 'blur(40px) saturate(1)',
  lineHeight: '1.6rem',
  borderRadius: '8px',
  '&::before': {
    content: '""',
    background: statusColor,
    position: 'absolute',
    height: '30px',
    right: 0,
    left: 0,
    top: 0,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  '.action-bars': {
    right: 10,
    '.close-popup': {
      height: '28px',
      svg: {
        width: '16px',
      },
      '&:hover': {
        filter: `drop-shadow(0 0 5px ${colors.black03})`
      }
    },
    '.btn-more': {
      boxShadow: 'none !important',
      border: 'none !important',
      svg: {
        height: '30px',
      },
      path: {
        stroke: `${colors.white} !important`
      },
      '&:hover': {
        filter: `drop-shadow(0 0 4px ${colors.black03})`
      }
    },
  },
  '.spacial-info': {
    '.title': {
      color: colors.themeMainColor,
      fontSize: '14px',
      fontWeight: 500,
      svg: {
        width: '16px'
      }
    },
    '.btn-expanded': {
      flex: 'none',
      width: 16,
      height: 16,
      borderRadius: 100,
      backgroundColor: colors.lightGray
    }
  },
  '.dropdown-menu': {
    width: '170px',
    '.dropdown-item': {
      '&:hover': {
        backgroundColor: colors.themeSecondColor06,
        color: colors.themeSecondColor
      }
    },
    '.print-group': {
      position: 'relative',
      cursor: 'pointer',
      '.icon-up': {
        display: 'none',
      },
      '.print-submenu': {
        display: 'none',
        position: 'absolute',
        top: '100%',
        right: 0,
        backgroundColor: colors.white,
        boxShadow: `0px 4px 5px ${colors.black10}`,
        zIndex: 300,
        flexDirection: 'column',
        padding: '4px 0'
      },
      '&:hover': {
        '.icon-down': {
          display: 'none',
        },
        '.icon-up': {
          display: 'inline-block',
        },
        '.print-group:hover + .print-submenu': {
          display: 'flex'
        }
      }
    },
  }
}))

const LabTag = styled(Box)(({ theme }) => ({
  backgroundColor: colors.themeThirdColor,
  color: colors.white,
  borderRadius: 4,
  width: 'max-content',
  height: 'max-content',
  fontSize: '0.75rem',
  lineHeight: 'normal',
  padding: '1px 4px'
}))

const ImageLabel = styled(Image)(({ theme }) => ({
  verticalAlign: 'top',
  marginTop: '5px',
  marginRight: '4px'
}))

const TypographyNote = styled(Typography)(({ theme }) => ({
  width: 'calc(100% - 80px)',
  fontSize: 16,
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word'
}))

const menuItemStyle = {
  paddingTop: '10px',
  paddingBottom: '10px',
  justifyContent: 'flex-start',
  minHeight: '40px',
  '&:hover': {
    backgroundColor: colors.themeSecondColor06,
    color: colors.themeSecondColor,
    '& .MuiListItemText-primary': {
      color: colors.themeSecondColor,
    },
    '& .MuiListItemIcon-root .MuiSvgIcon-root': {
      color: colors.themeSecondColor,
    }
  },
  cursor: 'pointer',
};
const listItemIconStyle = {
  minWidth: '40px',
  color: colors.themeSecondColor,
};
const listItemTextStyle = {
  primaryTypographyProps: {
    fontSize: '0.95rem',
    color: colors.textPrimary,
    fontWeight: 500,
    '&:hover': {
      color: colors.themeSecondColor
    },
  },
};

const subMenuItemSx = {
  ...menuItemStyle
};
const langMenuItemSx = {
  ...menuItemStyle,
  minHeight: '36px',
  paddingTop: '6px',
  paddingBottom: '6px'
};


const sxMobile = {
  zIndex: 9999,
  background: 'white',
  height: '100%',
  with: '100%',
  justifyContent: 'center',
  '@media print': {
    width: '80mm !important',
    maxWidth: '80mm !important',
    display: 'block !important',
    marginLeft: 'auto !important',
    marginRight: 'auto !important',
    position: 'static !important',
    transform: 'none !important',
  },
};

export default function CardAppointmentDetail(props: CardSchedule) {
  const { t, i18n } = useTranslation()
  const lang = i18n?.language || 'th'
  const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView(),
    isExport: isExport()
  }

  const user = useSelector(selectMe)
  /** Branch input-visibility settings (formAppointment) — same source the booking form uses
   *  to decide which inputs to render. Card rows follow the same isShow flag so the detail
   *  popup matches what was captured. */
  const formAppointments: any[] = useSelector(formAppointment) || []
  const isFieldShown = (id: string) => {
    if (!formAppointments?.length) return true
    const setting = _.find(formAppointments, { id })
    return setting ? _.get(setting, 'isShow') !== false : true
  }
  const specialInfoRef = useRef(null);
  const [dropDown, setDropDown] = useState<boolean>(props.showPopup || false)

  const [appointment, setAppointment] = useState<AppointmentInterface | undefined>()
  const [transform, setTransform] = useState(0)
  const [transformX, setTransformX] = useState(0)
  const [statusColor, setStatusColor] = useState(colors.lightGray)
  const [positionCard, setPositionCard] = useState<'top' | 'bottom'>('top')

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [isShow, setIsShow] = useState(false);
  /** TDH customization (QT-TDH-2026-003 v3.1) — channel lookup for display */
  const [appointmentChannels, setAppointmentChannels] = useState<Array<{ appointmentChannelId: number; channelName: string }>>([])
  useEffect(() => {
    ComponentApi.findAllAppointmentChannels().then((res: any) => {
      if (res?.status === 200) setAppointmentChannels(res.data || [])
    })
  }, [])
  const [show, setShow] = useState(false)

  const unit = scale.rangeOfMinute
  const [branch, setBranch] = useState<any>()
  const [branchInfo, setBranchInfo] = useState<any>()

  const size = UseWindowSize()
  const pdfThemalENRef = useRef<HTMLDivElement | null>(null);
  const pdfThemalTHRef = useRef<HTMLDivElement | null>(null);
  const pdfA5THRef = useRef<HTMLDivElement | null>(null);
  const pdfA5ENRef = useRef<HTMLDivElement | null>(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isPrintOpen, setIsPrintOpen] = useState(false)
  const [isPrintOpenA5, setIsPrintOpenA5] = useState(false)
  const [isPrintOpenThemal, setIsPrintOpenThemal] = useState(false)


  const [pdfThemalEN, setPdfThemalEN] = useState(false)
  const [pdfThemalTH, setPdfThemalTH] = useState(false)
  const [pdfA5TH, setPdfA5TH] = useState(false)
  const [pdfA5EN, setPdfA5EN] = useState(false)
  const [printingMode, setPrintingMode] = useState('');
  const [loadingOpd, setLoadingOpd] = useState<boolean>(false)


  useEffect(() => {
    setBranch(props.branch)
  }, [props.branch])

  useEffect(() => {
    setDropDown(props.showPopup)
  }, [props.showPopup])

  const loadAppointmentById = useCallback(async () => {
    if (!props.appointmentId) return setAppointment(undefined)
    const ap: any = await AppointmentApi.findById(props.appointmentId)
    if (ap.status === 200) {
      setAppointment(ap.data)
      const res = await AboutUs.detailClinic(Number(ap.data.branchId))
      if (res.status === 200) setBranchInfo(res.data)

    }
  }, [props?.appointmentId])

  const handlePatientCode = () => {
    if (branch?.patientCodeAppointment === '1') {
      return appointment?.cnNumber
    }
    if (branch?.patientCodeAppointment === '0') {
      return appointment?.branchCnNumber
    }
    if (branch?.patientCodeAppointment === '2') {
      return appointment?.snCode || ''
    }
  }

  const handleNowPoint = useCallback(() => {
    if (appointment?.timeStart) {
      const start = moment(appointment?.timeStart, 'HH:mm')
      const defaultTime = props.timeStart ? moment(props.timeStart, 'HH:mm') : moment('09:00', 'HH:mm')
      const diffTransform = moment.duration(start.diff(defaultTime)).asMinutes()

      let pos: 'top' | 'bottom' = 'top'
      const conDiv: any = document.querySelector(`.container-schedule [data-value="${props.appointmentId}"]`)
      const conSchedule: any = document.querySelector(`.container-schedule`)
      let translateY
      let newTranslateY = 0
      let newTranslateX = 0

      const conMaxWidth = document.querySelector(`.display-days`)
      const maxWidth = conMaxWidth?.clientWidth || size[0]

      if (conDiv) {
        const style = getComputedStyle(conDiv);
        const transform = style.getPropertyValue('transform');
        const matrix = new DOMMatrix(transform);
        translateY = matrix.m42;

        // sizeSectionAppointment === 284 && 
        if (props?.popAutoScroll) {
          const rect = conDiv.getBoundingClientRect();
          newTranslateY = rect.top
          newTranslateX = rect.left
          if (newTranslateX + 350 > maxWidth) {
            newTranslateX = (maxWidth - 366 < 0) ? 0 : maxWidth - 366
          } else if (newTranslateX < 0) {
            newTranslateX = 0
          }
          setTransformX(newTranslateX)
        }
      }
      let trans = translateY || diffTransform * unit
      const cardDetail: any = document.querySelector(`.card-detail-${props.appointmentId}`)
      const cardHeight: number = cardDetail?.offsetHeight || 350
      if ((cardHeight + newTranslateY) > size[1]) {
        newTranslateY = size[1] - cardHeight - 32 - 10
      }

      if (props.timeEnd) {
        const end = moment(props.timeEnd, 'HH:mm')
        const diffTransformEnd = moment.duration(end.diff(start)).asHours()
        const diffAllTime = moment.duration(end.diff(defaultTime)).asHours()
        if (diffTransformEnd < 3) {
          trans = trans - cardHeight
          pos = 'bottom'
        }

        if (trans <= 0) {
          trans = (translateY || diffTransform * unit)
        }

        if (trans > conSchedule?.offsetHeight) {
          trans = (translateY || diffTransform * unit) - cardHeight
        }

        if (diffAllTime <= 2) {
          trans = 0
        }
      }
      getColorAppointmentStatus()
      setPositionCard(pos)
      setTransform(newTranslateY || trans)
    }
  }, [appointment])

  useEffect(() => {
    if (props.showPopup) loadAppointmentById()
    else setAppointment(undefined)
  }, [props.showPopup, props.appointmentId])

  useEffect(() => {
    if (props.showPopup) handleNowPoint()
  }, [appointment])

  const getColorAppointmentStatus = useCallback(() => {
    let color: any = colors.lightGray
    if (appointment?.statusAppointment === 'CONFIRM') color = colors.appointmentStatus.statusEnter
    if (appointment?.statusAppointment === 'NOT_YET') color = colors.appointmentStatus.statusUnArrived
    if (appointment?.statusAppointment === 'CANCEL') color = colors.appointmentStatus.statusCancel
    if (appointment?.statusAppointment === 'CANCEL_APP') color = colors.appointmentStatus.statusCancel
    if (appointment?.statusAppointment === 'CAN_NOT_CONTACT') color = colors.appointmentStatus.statusUnConnect
    if (appointment?.statusAppointment === 'ARRIVED') color = colors.appointmentStatus.statusArrived

    // 
    if (appointment?.statusAppointment === 'PENDING_PAYMENT') color = colors.appointmentStatus.statusPayment
    if (appointment?.statusAppointment === 'PAYMENT') color = colors.appointmentStatus.statusWaitPayment
    if (appointment?.statusAppointment === 'PENDING_SERVICE') color = colors.appointmentStatus.statusCounterCheckIn
    if (appointment?.statusAppointment === 'SERVICE') color = colors.appointmentStatus.statusService
    //

    if (appointment?.statusAppointment === 'PUT_OFF') color = colors.appointmentStatus.statusChange
    if (appointment?.statusAppointment === 'DONE') color = colors.appointmentStatus.statusDone
    if (appointment?.statusAppointment === 'NORMAL') color = colors.appointmentStatus.statusNormal

    return setStatusColor(color)
  }, [appointment])

  const formatPhoneNumber = (phoneNumberString: string) => {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`
    }
    return phoneNumberString
  }

  const sizeSpecialBox = () => {
    const ref: any = specialInfoRef?.current
    return ref?.offsetWidth
  }

  const valPractice = (val: string) => {
    if (val.charAt(0) === ',' || val.charAt(0) === ' ') {
      val = val.substring(1);
    }
    return val
  }

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector('.service-slider-container');
      const conDiv: any = document.querySelector(`.container-schedule [data-value="${props.appointmentId}"]`)
      if (element && conDiv && props?.popAutoScroll) {
        const rect = conDiv.getBoundingClientRect();
        setTransform(rect.top)
        setTransformX(rect.left)
      }
    };

    const element = document.querySelector('.service-slider-container');
    if (element) {
      element.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);



  const resetAll = () => {
    setIsPrintOpen(false)
    setIsPrintOpenA5(false)
    setIsPrintOpenThemal(false)
    setDropDown(false)
    setIsMenuOpen(false)
  }

  const handlePrintA4Thermal = (type: string) => {
    setPrintingMode(type);
    if (type) {
      setTimeout(() => {
        window.print();
      }, 1000);
    }
  };

  const handlePrintOpdAppointment = (id: number) => {
    setLoadingOpd(true)
    exportOPDAppointment(id, lang)
      .catch((e) => {
        setLoadingOpd(false)
      })
      .finally(() => {
        setLoadingOpd(false)
      })
  }

  const CardDetail = () => {
    return (
      <Box sx={{ width: props.width === 500 ? '350px' : '290px', paddingRight: '30px' }}>
        <Tooltip placement='top-start' title={appointment?.patientFullname}>
          <Typography className='text-ellipsis' sx={{ color: colors.themeMainColor, fontWeight: 500 }}>
            {handlePatientCode() || ''} {handlePatientCode() ? ' | ' : ''} {appointment?.patientFullname}
          </Typography>
        </Tooltip>
        {isFieldShown('spacialInfo') && (
          <Box className={`spacial-info d-flex`}>
            <Box className={`mr-1 ${!isExpanded ? 'text-ellipsis' : ''}`}>
              <Typography className='title d-inline align-text-bottom' sx={{ svg: { width: '16px', height: '16px' } }}>
                <IconStar stroke={colors.themeMainColor} />
                <span className='ml-1 align-middle'>{t('REGISTER.SPACIAL_INFO')}</span>
                <span className='px-1 align-middle'>:</span>
              </Typography>
              <Typography ref={specialInfoRef} className='d-inline'>
                {appointment?.specialInfo || '-'}
              </Typography>
            </Box>
            {(appointment?.specialInfo && sizeSpecialBox() > 190) && (
              <IconButton onClick={() => setIsExpanded(!isExpanded)} className='p-0 mt-1 ml-auto btn-expanded d-flex align-items-center' sx={{ boxShadow: 'none !important' }}>
                <KeyboardArrowDownIcon sx={{ fontSize: '16px', color: colors.textPrimary, transform: `rotate(${isExpanded ? '180deg' : '0deg'})` }} />
              </IconButton>
            ) || <></>}
          </Box>
        )}
        <Box className='d-flex ml-2 my-1'>
          {isFieldShown('lab') && <LabTag className='mr-1' sx={{ display: appointment?.hasLab === 'HAS' ? '' : 'none' }}>LAB</LabTag>}
          {isFieldShown('xray') && <LabTag sx={{ display: appointment?.hasXray === 'HAS' ? '' : 'none' }}>X-RAY</LabTag>}
        </Box>
        <Divider className="mx-0 my-1" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
        <Box
          sx={{
            flex: 1,
            maxHeight: `${window.innerHeight >= 958 ? '350px' : '300px'}`,
            overflowY: 'auto',
            overflowX: 'hidden',
            cursor: 'auto',
            pr: '10px',
            paddingTop: '10px'
          }}
          tabIndex={0}
        >
          {isFieldShown('doctor') && (
            <Box className='d-flex align-items-start' sx={{ svg: { width: '16px' } }}>
              <Box sx={{ flex: 'none', width: '16px' }}>
                <Icons.Schedule color={colors.themeMainColor} />
              </Box>
              <Typography className='ml-2' sx={{ flex: 1, paddingTop: '3px' }}>{`${t('DOCTOR_PREFIX')} ${appointment?.doctorFullname}`}</Typography>
            </Box>
          )}
          {isFieldShown('timeStart') && (
            <Box className='d-flex align-items-start'>
              <Box sx={{ flex: 'none', width: '16px' }}><Image src={iconTime} style={{ width: '15px' }} /></Box>
              <Typography className='ml-2' sx={{ flex: 1, paddingTop: '3px' }}>{`${moment(appointment?.timeStart, 'HH:mm').format('HH.mm')} - ${moment(appointment?.timeStart, 'HH:mm').add(appointment?.durationMinute, 'minute').format('HH.mm')} ${t('TIME_UNIT')}`}</Typography>
            </Box>
          )}
          {isFieldShown('phone') && !props.isNotShowPhoneNumber && (
            <Box className='d-flex align-items-start'>
              <Box sx={{ flex: 'none', width: '16px' }}><Image src={phone} style={{ width: '14px' }} /></Box>
              <Typography className='ml-2' sx={{ flex: 1, paddingTop: '3px' }}>{`${!_.isEmpty(appointment?.phone) ? formatPhoneNumber(String(appointment?.phone) || '') : '-'}`}</Typography>
            </Box>
          )}
          {isFieldShown('treatment') && (
            <Box className='d-flex align-items-start'>
              <Box sx={{ flex: 'none', width: '16px', svg: { width: '14px', path: { stroke: colors.themeMainColor } } }}>
                <ThemeIcon.Treatment />
              </Box>
              <Typography className='ml-2' sx={{ flex: 1, paddingTop: '3px' }}>{appointment?.appointmentOperatives?.map((op: AppointmentOperativeInterface) => (op.operativeName ? op.operativeName : op.operativeTypeName)).join(', ')}</Typography>
            </Box>
          )}
          {
            appointment?.hasLab === 'HAS' || appointment?.hasXray === 'HAS' && (
              <Box className='d-flex align-items-start'>
                <Box sx={{ opacity: 0, flex: 'none', width: '16px', svg: { width: '14px' } }}>
                  <ThemeIcon.Treatment />
                </Box>
                <Box className='d-flex ml-2 my-1'>
                  {isFieldShown('lab') && <LabTag className='mr-1' sx={{ display: appointment?.hasLab === 'HAS' ? '' : 'none' }}>LAB</LabTag>}
                  {isFieldShown('xray') && <LabTag sx={{ display: appointment?.hasXray === 'HAS' ? '' : 'none' }}>X-Ray</LabTag>}
                </Box>
              </Box>
            ) || <></>
          }
          {isFieldShown('price') && (
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none' }}>{t('APPOINTMENT.APPOINT_PRICE')} :</Typography>
              <Typography className='ml-1' sx={{ flex: 1 }}>{`${numberFormat(appointment?.price) || '-'} ${t('CURRENCY_CHANGE.TH')}`}</Typography>
            </Box>
          )}
          {/** 'การปฏิบัติ' row removed — practice column now stores Special Request data (merged) */}
          {/* TDH customization (QT-TDH-2026-003 v3.1) — gated on branch input visibility (formAppointment isShow) */}
          {isFieldShown('chiefComplaint') && appointment?.chiefComplaint && (
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none', width: '120px' }}>{t('APPOINTMENT.FORM.CHIEF_COMPLAINT')} :</Typography>
              <Typography className='ml-1' sx={{ flex: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{appointment.chiefComplaint}</Typography>
            </Box>
          )}
          {/** Special Request reads from the merged practice column */}
          {isFieldShown('specialRequest') && appointment?.practice && (
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none', width: '120px' }}>{t('APPOINTMENT.FORM.SPECIAL_REQUEST')} :</Typography>
              <Typography className='ml-1' sx={{ flex: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{appointment.practice}</Typography>
            </Box>
          )}
          {isFieldShown('appointmentChannelId') && appointment?.appointmentChannelId && (
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none', width: '120px' }}>{t('APPOINTMENT.FORM.APPOINTMENT_CHANNEL')} :</Typography>
              <Typography className='ml-1' sx={{ flex: 1 }}>
                {appointmentChannels.find((c) => c.appointmentChannelId === appointment.appointmentChannelId)?.channelName || '-'}
              </Typography>
            </Box>
          )}
          {isFieldShown('feedback') && appointment?.feedback && (
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none', width: '120px' }}>{t('APPOINTMENT.FORM.FEEDBACK')} :</Typography>
              <Typography className='ml-1' sx={{ flex: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{appointment.feedback}</Typography>
            </Box>
          )}
          {isFieldShown('note') && (
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none', width: '75px' }}>{t('APPOINTMENT.FORM.REMARK')} :</Typography>
              <Typography className='ml-1' sx={{
                flex: 1,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}> {valPractice(appointment?.remark || '-') || '-'}</Typography>
            </Box>
          )}
          <Box className='d-flex align-items-start'>
            <Typography sx={{ flex: 'none', width: '75px' }}>{t('APPOINTMENT.FORM.CREATE_BY')} :</Typography>
            <Typography className='ml-1' sx={{ flex: 1 }}>{appointment?.createdBy || '-'} {t('APPOINTMENT.FORM.DATEOF')} {dateTimeToView(appointment?.createdAt, false)}</Typography>
          </Box>
          <Box className='d-flex align-items-start'>
            <Typography sx={{ flex: 'none', width: '75px' }}>{t('APPOINTMENT.FORM.UPDATE_BY')} :</Typography>
            <Typography className='ml-1' sx={{ flex: 1 }}>{appointment?.updatedBy || '-'} {t('APPOINTMENT.FORM.DATEOF')} {dateTimeToView(appointment?.updatedAt, false)}</Typography>
          </Box>
          {
            appointment?.statusAppointment === 'CANCEL' &&
            <Box className='d-flex align-items-start'>
              <Typography sx={{ flex: 'none', width: '120px', color: 'red' }}>{t('APPOINTMENT.FORM.REMARK_CANCEL')} :</Typography>
              <TypographyNote className='ml-1' sx={{ flex: 1 }}>{appointment?.remarkCancel || '-'}</TypographyNote>
            </Box>
          }
        </Box>
      </Box >
    )
  }


  const CardViewDetailBox = () => {
    return (
      <Box>
        {size[0] > 1366 &&
          <CardViewDetail
            key={props.key ?? 1}
            fixPosition={props?.fixPosition}
            transform={transform}
            dropDown={dropDown}
            appointment={appointment}
            statusColor={statusColor}
            positioncard={positionCard}
            position={(props?.popAutoScroll) ? 'fixed' : 'absolute'}
            transformx={transformX}
            className={`card-ap-detail card-detail-${props.appointmentId}`}
            width={props.width}
            displayType={props.displayType}
          >
            <div className='action-bars position-absolute top-0 d-flex align-items-center'>
              {!props.hideMenu
                && <div style={{ marginLeft: 'auto' }}>
                  <Dropdown
                    show={isMenuOpen}
                    onToggle={nextShow => {
                      setIsMenuOpen(nextShow)
                      if (!nextShow) setIsPrintOpen(false)
                    }}
                  >
                    <Dropdown.Toggle variant="link" bsPrefix="p-0" className="text-black-50 btn-more">
                      <IconEllipsis />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      style={{ fontSize: '16px', width: props.status !== 'DONE' ? 'auto' : 220 }}>
                      {props.status !== 'DONE' &&
                        <>
                          <Dropdown.Item disabled={permissions.isView.disabled} onClick={() => {
                            window.open(`${routeName.treatmentsEmrHistory}?patientId=${appointment?.patientId}`, '_blank')
                            props?.onClose && props?.onClose(props.appointmentId)
                            setDropDown(false)
                            setIsShow(false)
                          }}>{t('APPOINTMENT.VIEW_EMR')}
                          </Dropdown.Item>
                          <Dropdown.Divider style={{ borderTop: 'none' }} />
                          <Dropdown.Item disabled={permissions.isUpdate.disabled} onClick={(e) => (
                            props?.onEdit ? (
                              props?.onEdit(props.appointmentId),
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false), setIsShow(false)) : (
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)
                            ))}
                          > <ImageLabel src={iconEdit} className="pr-1" />
                            {t('APPOINTMENT.EDIT')}
                          </Dropdown.Item>
                          {/* พิมพ์ใบ opd นัดหมาย */}
                          {/* {branchInfo?.opdCardAppointment === "1" && <Dropdown.Item disabled={permissions.isExport.disabled} onClick={() => handlePrintOpdAppointment(props.appointmentId)}
                          > <ImageLabel src={print} className="pr-1" />
                            {t('REGISTER.BUTTON.OPD_APPOINTMENT')}
                          </Dropdown.Item>} */}
                          <Dropdown.Item
                            as="div"
                            disabled={permissions.isExport.disabled}
                            className="print-group d-flex align-items-center"
                            onClick={e => {
                              e.stopPropagation()
                              setIsPrintOpen(v => !v)
                            }}
                          >
                            <ImageLabel src={print} className="pr-1" />
                            {t('APPOINTMENT.PRINT')}
                            <div style={{ marginLeft: 'auto' }}>
                              {isPrintOpen
                                ? <ArrowDropUpIcon sx={{ fontSize: '18px' }} />
                                : <ArrowDropDownIcon sx={{ fontSize: '18px' }} />
                              }
                            </div>
                          </Dropdown.Item>
                          {isPrintOpen && <div className='print-submenu'>
                            <Dropdown.Item
                              as="div"
                              disabled={permissions.isExport.disabled}
                              className="print-group d-flex align-items-center"
                              onClick={e => {
                                e.stopPropagation()
                                setIsPrintOpenThemal(v => !v)
                              }}
                            >
                              {t('APPOINTMENT.PRINT_THEMAL')}
                              <div style={{ marginLeft: 'auto' }}>
                                {isPrintOpenThemal
                                  ? <ArrowDropUpIcon sx={{ ml: 1, fontSize: '18px' }} />
                                  : <ArrowDropDownIcon sx={{ ml: 1, fontSize: '18px' }} />
                                }
                              </div>
                            </Dropdown.Item>
                            {isPrintOpenThemal && <div className='print-submenu'>
                              <Dropdown.Item disabled={permissions.isExport.disabled}>
                                <FunctionPrint
                                  content={() => pdfThemalTHRef.current}
                                  removeIfram
                                  trigger={() => (
                                    <div onClick={() => setShow(false)}>
                                      <FiberManualRecordIcon sx={{ width: 12, height: 12, mr: 1, ml: 2 }} />
                                      TH
                                    </div>
                                  )}
                                  style={() => {
                                    const h = (appointment?.appointmentOperatives ?? ['1']).length * 5
                                    return `
                                      @page {size: 80mm ${145 + h}mm !important; margin: 0 !important;}
                                        body {
                                          margin: 0 !important;
                                          padding: 0 !important;
                                          width: 100% !important;
                                          box-sizing: border-box;
                                        }
                                        * {
                                        box-sizing: border-box;
                                      }
                                  `;
                                  }}
                                /></Dropdown.Item>
                              <Dropdown.Item disabled={permissions.isExport.disabled}>
                                <FunctionPrint
                                  content={() => pdfThemalENRef.current}
                                  removeIfram
                                  trigger={() => (
                                    <div onClick={() => setShow(false)}>
                                      <FiberManualRecordIcon sx={{ width: 12, height: 12, mr: 1, ml: 2 }} />
                                      EN
                                    </div>
                                  )}
                                  style={() => {
                                    const h = (appointment?.appointmentOperatives ?? ['1']).length * 5
                                    return `
                                      @page {
                                              size: 80mm ${145 + h}mm !important;
                                              margin: 0 !important;
                                        }
                                        body {
                                          margin: 0 !important;
                                          padding: 0 !important;
                                          width: 100% !important;
                                          box-sizing: border-box;
                                        }
                                        * {
                                        box-sizing: border-box;
                                      }
                                  `;
                                  }}
                                />
                              </Dropdown.Item>
                            </div>}
                            <Dropdown.Item
                              as="div"
                              disabled={permissions.isExport.disabled}
                              className="print-group d-flex align-items-center"
                              onClick={e => {
                                e.stopPropagation()
                                setIsPrintOpenA5(v => !v)
                              }}
                            >
                              {t('APPOINTMENT.PRINT_A5')}
                              <div style={{ marginLeft: 'auto' }}>
                                {isPrintOpenA5
                                  ? <ArrowDropUpIcon sx={{ ml: 1, fontSize: '18px' }} />
                                  : <ArrowDropDownIcon sx={{ ml: 1, fontSize: '18px' }} />
                                }
                              </div>
                            </Dropdown.Item>
                            {isPrintOpenA5 && <div className='print-submenu'>
                              <Dropdown.Item disabled={permissions.isExport.disabled}>
                                <FunctionPrint
                                  content={() => pdfA5THRef.current}
                                  removeIfram
                                  trigger={() => (
                                    <div onClick={() => setShow(false)}>
                                      <FiberManualRecordIcon sx={{ width: 12, height: 12, mr: 1, ml: 2 }} />
                                      TH
                                    </div>
                                  )}
                                  style={'@page { size: A5 landscape !important; margin: 0 }'}
                                /></Dropdown.Item>
                              <Dropdown.Item disabled={permissions.isExport.disabled}>
                                <FunctionPrint
                                  content={() => pdfA5ENRef.current}
                                  removeIfram
                                  trigger={() => (
                                    <div onClick={() => setShow(false)}>
                                      <FiberManualRecordIcon sx={{ width: 12, height: 12, mr: 1, ml: 2 }} />
                                      EN
                                    </div>
                                  )}
                                  style={'@page { size: A5 landscape !important; margin: 0 }'}
                                /></Dropdown.Item>
                            </div>}
                          </div>}
                        </>
                        ||
                        <>
                          <Dropdown.Item disabled={permissions.isView.disabled} onClick={() => {
                            window.open(`${routeName.treatmentsEmrHistory}?patientId=${appointment?.patientId}`, '_blank')
                            props?.onClose && props?.onClose(props.appointmentId)
                            setDropDown(false)
                          }}>{t('APPOINTMENT.VIEW_EMR')}
                          </Dropdown.Item>
                          <Dropdown.Divider style={{ borderTop: 'none' }} />
                          <Dropdown.Item disabled={permissions.isUpdate.disabled} onClick={(e) => (
                            props?.onEditSpecialInfo ? (
                              props?.onEditSpecialInfo(props.appointmentId),
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)) : (
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)
                            ))}>
                            <ImageLabel src={iconEdit} className="pr-1" />
                            {t('APPOINTMENT.EDIT_SPECIALINFO')}
                          </Dropdown.Item>
                          {/* TDH customization — edit Feedback only (does not affect status/other fields) */}
                          <Dropdown.Item disabled={permissions.isUpdate.disabled} onClick={(e) => (
                            props?.onEditFeedback ? (
                              props?.onEditFeedback(props.appointmentId),
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)) : (
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)
                            ))}>
                            <ImageLabel src={iconEdit} className="pr-1" />
                            แก้ไข Feedback
                          </Dropdown.Item>
                        </>
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </div>}
              <div style={{ marginLeft: '10px' }}>
                <div
                  className='cursor-pointer close-popup d-flex align-items-center'
                  onClick={(e) => {
                    setDropDown(false)
                    if (props?.onClose) props?.onClose(props.appointmentId)
                  }}>
                  <ClosePopup />
                </div>
              </div>
            </div>
            <CardDetail />
          </CardViewDetail >
        }

        {size[0] < 1366 &&
          <Box id='my-card-detail-to-hide'
            sx={{ flex: '0', zIndex: 100, flexDirection: 'column', width: '350px', height: 'auto', backgroundColor: colors.white80, boxShadow: `0px 4px 5px ${colors.black10}`, borderTop: '10px', border: `1px solid ${colors.borderHeaderCard}`, opacity: '1', backdropFilter: 'blur(40px) saturate(1)', lineHeight: '1.6rem', borderRadius: '8px', }}>
            <Box sx={{ background: statusColor, position: 'absolute', height: '30px', right: 0, left: 0, top: 0, borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
              <Box display={'flex'} flexDirection={'row'} textAlign={'end'} justifyContent={'flex-end'}>
                <Box sx={{ pointerEvents: 'auto', zIndex: 10 }}>
                  <Box onClick={(e) => {
                    e.stopPropagation()
                    setIsMenuOpen(v => !v)
                    if (isMenuOpen) resetAll()
                  }}><IconEllipsis color={colors.white} /></Box>
                  {isMenuOpen && <Paper sx={{ width: props.status !== 'DONE' ? 190 : 250, maxWidth: '100%', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)', border: `1px solid ${colors.lightGray}` }} >
                    <MenuList disablePadding sx={{ position: 'relative' }}>
                      {props.status !== 'DONE' ? (
                        <Box>
                          {/* ดู EMR */}
                          <MenuItem sx={menuItemStyle} disabled={permissions.isView.disabled} onClick={() => {
                            window.open(`${routeName.treatmentsEmrHistory}?patientId=${appointment?.patientId}`, '_blank')
                            props?.onClose && props?.onClose(props.appointmentId)
                            setDropDown(false)
                            setIsShow(false)
                          }}>
                            <ListItemText primary={t('APPOINTMENT.VIEW_EMR')} {...listItemTextStyle} sx={{ textAlign: 'start', }} />
                          </MenuItem>
                          <Box sx={{ border: `0.5px solid ${colors.lightGray}` }} />
                          {/* แก้ไข */}
                          <MenuItem sx={menuItemStyle} disabled={permissions.isUpdate.disabled} onClick={(e) => (
                            props?.onEdit ? (
                              props?.onEdit(props.appointmentId),
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false), setIsShow(false)) : (
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)
                            ))}>
                            <ListItemIcon sx={listItemIconStyle}>
                              <ImageLabel src={iconEdit} className="pr-1" />
                            </ListItemIcon>
                            <ListItemText primary={t('APPOINTMENT.EDIT')} {...listItemTextStyle} sx={{ textAlign: 'start' }} />
                          </MenuItem>

                          {/* พิมพ์ใบ opd นัดหมาย */}
                          {/* {branchInfo?.opdCardAppointment === "1" && <MenuItem sx={menuItemStyle} disabled={permissions.isExport.disabled} onClick={() => handlePrintOpdAppointment(props.appointmentId)}>
                            <ListItemIcon sx={listItemIconStyle}>
                              <ImageLabel src={print} className="pr-1" />
                            </ListItemIcon>
                            <ListItemText primary={t('REGISTER.BUTTON.OPD_APPOINTMENT')} {...listItemTextStyle} sx={{ textAlign: 'start' }} />
                          </MenuItem>} */}

                          {/* พิมพ์ใบนัด */}
                          <MenuItem sx={menuItemStyle} disabled={permissions.isExport.disabled} onClick={e => {
                            e.stopPropagation()
                            setIsPrintOpen(v => !v)
                          }}>
                            <ListItemIcon sx={listItemIconStyle}>
                              <ImageLabel src={print} className="pr-1" />
                            </ListItemIcon>
                            <ListItemText primary={t('APPOINTMENT.PRINT')} {...listItemTextStyle} sx={{ textAlign: 'start' }} />
                            {isPrintOpen
                              ? <ArrowDropUpIcon sx={{ ml: 1, fontSize: '18px' }} />
                              : <ArrowDropDownIcon sx={{ ml: 1, fontSize: '18px' }} />
                            }
                          </MenuItem>
                          <Collapse in={isPrintOpen} timeout="auto" unmountOnExit>
                            <MenuList disablePadding sx={{ ml: 0 }}>
                              {/* ใบนัด Thermal */}
                              <MenuItem sx={subMenuItemSx} disabled={permissions.isExport.disabled} onClick={e => {
                                e.stopPropagation()
                                setIsPrintOpenThemal(v => !v)
                              }}>
                                <ListItemText primary={t('APPOINTMENT.PRINT_THEMAL')} {...listItemTextStyle} sx={{ ml: 1, textAlign: 'start', justifyContent: 'flex-start' }} />
                                {isPrintOpenThemal
                                  ? <ArrowDropUpIcon sx={{ ml: 1, fontSize: '18px' }} />
                                  : <ArrowDropDownIcon sx={{ ml: 1, fontSize: '18px' }} />
                                }
                              </MenuItem>
                              <Collapse in={isPrintOpenThemal} timeout="auto" unmountOnExit>
                                <MenuList disablePadding>
                                  <MenuItem sx={langMenuItemSx} disabled={permissions.isExport.disabled} onClick={(e: any) => {
                                    // e.stopPropagation();
                                    handlePrintA4Thermal('THERMAL_TH')
                                  }}>
                                    {/* FunctionPrint TH Thermal */}
                                    <Box display="flex" alignItems="center" width="100%">
                                      <ListItemIcon sx={{ ...listItemIconStyle, minWidth: '28px', pr: 0.5, pl: 2 }}>
                                        <FiberManualRecordIcon sx={{ fontSize: '0.6rem', color: colors.black }} />
                                      </ListItemIcon>
                                      <ListItemText primary="TH" primaryTypographyProps={{ ...listItemTextStyle.primaryTypographyProps, fontSize: '0.9rem', textAlign: 'start' }} />
                                    </Box>
                                  </MenuItem>
                                  <MenuItem sx={langMenuItemSx} disabled={permissions.isExport.disabled} onClick={(e: any) => {
                                    // e.stopPropagation();
                                    handlePrintA4Thermal('THERMAL_EN')
                                  }}>
                                    {/* FunctionPrint EN Thermal */}
                                    <Box display="flex" alignItems="center" width="100%">
                                      <ListItemIcon sx={{ ...listItemIconStyle, minWidth: '28px', pr: 0.5, pl: 2 }}>
                                        <FiberManualRecordIcon sx={{ fontSize: '0.6rem', color: colors.black }} />
                                      </ListItemIcon>
                                      <ListItemText primary="EN" primaryTypographyProps={{ ...listItemTextStyle.primaryTypographyProps, fontSize: '0.9rem', textAlign: 'start' }} />
                                    </Box>
                                  </MenuItem>
                                </MenuList>
                              </Collapse>
                              {/* ใบนัด A5 */}
                              <MenuItem sx={subMenuItemSx} disabled={permissions.isExport.disabled} onClick={e => {
                                e.stopPropagation()
                                setIsPrintOpenA5(v => !v)
                              }}>
                                <ListItemText primary={t('APPOINTMENT.PRINT_A5')} {...listItemTextStyle} sx={{ ml: 1, textAlign: 'start', justifyContent: 'flex-start' }} />
                                {isPrintOpenA5
                                  ? <ArrowDropUpIcon sx={{ ml: 1, fontSize: '18px' }} />
                                  : <ArrowDropDownIcon sx={{ ml: 1, fontSize: '18px' }} />
                                }
                              </MenuItem>
                              <Collapse in={isPrintOpenA5} timeout="auto" unmountOnExit>
                                <MenuList disablePadding>
                                  <MenuItem sx={langMenuItemSx} disabled={permissions.isExport.disabled} onClick={(e: any) => {
                                    // e.stopPropagation();
                                    handlePrintA4Thermal('A5_TH')
                                  }}>
                                    {/* FunctionPrint TH Thermal */}
                                    <Box display="flex" alignItems="center" width="100%" >
                                      <ListItemIcon sx={{ ...listItemIconStyle, minWidth: '28px', pr: 0.5, pl: 2 }}>
                                        <FiberManualRecordIcon sx={{ fontSize: '0.6rem', color: colors.black }} />
                                      </ListItemIcon>
                                      <ListItemText primary="TH" primaryTypographyProps={{ ...listItemTextStyle.primaryTypographyProps, fontSize: '0.9rem', textAlign: 'start' }} />
                                    </Box>
                                  </MenuItem>
                                  <MenuItem sx={langMenuItemSx} disabled={permissions.isExport.disabled} onClick={(e: any) => {
                                    // e.stopPropagation();
                                    handlePrintA4Thermal('A5_EN')
                                  }}>
                                    {/* FunctionPrint EN Thermal */}
                                    <Box display="flex" alignItems="center" width="100%">
                                      <ListItemIcon sx={{ ...listItemIconStyle, minWidth: '28px', pr: 0.5, pl: 2 }}>
                                        <FiberManualRecordIcon sx={{ fontSize: '0.6rem', color: colors.black }} />
                                      </ListItemIcon>
                                      <ListItemText primary="EN" primaryTypographyProps={{ ...listItemTextStyle.primaryTypographyProps, fontSize: '0.9rem', textAlign: 'start' }} />
                                    </Box>
                                  </MenuItem>
                                </MenuList>
                              </Collapse>
                            </MenuList>
                          </Collapse>
                        </Box>
                      ) : (
                        <Box>
                          <MenuItem sx={menuItemStyle} disabled={permissions.isView.disabled} onClick={() => {
                            window.open(`${routeName.treatmentsEmrHistory}?patientId=${appointment?.patientId}`, '_blank')
                            props?.onClose && props?.onClose(props.appointmentId)
                            setDropDown(false)
                            setIsShow(false)
                          }}>
                            <ListItemText primary={t('APPOINTMENT.VIEW_EMR')} {...listItemTextStyle} sx={{ textAlign: 'start' }} />
                          </MenuItem>
                          <Box sx={{ border: `0.5px solid ${colors.lightGray}` }} />
                          <MenuItem onClick={(e) => (
                            props?.onEditSpecialInfo ? (
                              props?.onEditSpecialInfo(props.appointmentId),
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)) : (
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)
                            ))} sx={menuItemStyle} disabled={permissions.isUpdate.disabled}>
                            <ListItemIcon sx={listItemIconStyle}>
                              <ImageLabel src={iconEdit} className="pr-1" />
                            </ListItemIcon>
                            <ListItemText primary={t('APPOINTMENT.EDIT_SPECIALINFO')} {...listItemTextStyle} sx={{ textAlign: 'start' }} />
                          </MenuItem>
                          {/* TDH customization — edit Feedback only (does not affect status/other fields) */}
                          <MenuItem onClick={(e) => (
                            props?.onEditFeedback ? (
                              props?.onEditFeedback(props.appointmentId),
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)) : (
                              props?.onClose && props?.onClose(props.appointmentId),
                              setDropDown(false)
                            ))} sx={menuItemStyle} disabled={permissions.isUpdate.disabled}>
                            <ListItemIcon sx={listItemIconStyle}>
                              <ImageLabel src={iconEdit} className="pr-1" />
                            </ListItemIcon>
                            <ListItemText primary={'แก้ไข Feedback'} {...listItemTextStyle} sx={{ textAlign: 'start' }} />
                          </MenuItem>
                        </Box>
                      )}
                    </MenuList>
                  </Paper>}
                </Box>
                <Box className="cursor-pointer close-popup d-flex align-items-center" sx={{ width: 15, height: 15, pointerEvents: 'auto', zIndex: 10, marginTop: '8px', marginX: '10px' }}
                  onClick={e => {
                    e.stopPropagation();
                    setDropDown(false);
                    props.onClose?.(props.appointmentId);
                  }}
                >
                  <ClosePopup />
                </Box>
              </Box>
            </Box >
            <Box sx={{ padding: '40px 15px 15px' }}><CardDetail /></Box>
          </Box >
        }

        {
          size[0] > 1366 && (
            <>
              <Box ref={pdfThemalTHRef} id="print-table-container" sx={sxMobile}>
                <PDFThermalTH branchInfo={branchInfo} appointment={appointment} user={user} />
              </Box >
              <Box ref={pdfThemalENRef} id="print-table-container" sx={sxMobile}>
                <PDFThermalEN branchInfo={branchInfo} appointment={appointment} user={user} />
              </Box>
              <Box ref={pdfA5THRef} id="print-table-container" overflow='hidden' height='105mm'>
                <PDFA5TH branchInfo={branchInfo} appointment={appointment} user={user} size={'lg'} />
              </Box >
              <Box ref={pdfA5ENRef} id="print-table-container" overflow='hidden' height='105mm'>
                <PDFA5EN branchInfo={branchInfo} appointment={appointment} user={user} size={'lg'} />
              </Box >
            </>
          )
        }
        {(printingMode === 'THERMAL_TH') &&
          <Box ref={pdfThemalTHRef} id="print-table-container" sx={sxMobile}>
            <PDFThermalTH branchInfo={branchInfo} appointment={appointment} user={user} />
          </Box >}
        {(printingMode === 'THERMAL_EN') &&
          <Box ref={pdfThemalENRef} id="print-table-container" sx={sxMobile}>
            <PDFThermalEN branchInfo={branchInfo} appointment={appointment} user={user} />
          </Box>}
        {(printingMode === 'A5_TH') &&
          <Box ref={pdfA5THRef} id="print-table-container" >
            <PDFA5TH branchInfo={branchInfo} appointment={appointment} user={user} size={'sm'} />
          </Box >}
        {(printingMode === 'A5_EN') &&
          <Box ref={pdfA5ENRef} id="print-table-container" className="no-page-break" >
            <PDFA5EN branchInfo={branchInfo} appointment={appointment} user={user} size={'sm'} />
          </Box >}
      </Box>
    )
  }


  if (size[0] > 1366) {
    return (
      <CardViewDetailBox />
    )
  }



  return (
    <>
      <Modal
        open={!!props.appointmentId && props?.showPopup}
        onClose={() => {
          props?.onClose && props?.onClose(props.appointmentId)
          resetAll()
        }}
        sx={{
          // zIndex: 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '@media print': {
            position: 'static !important',
            overflow: 'visible !important',
            backgroundColor: 'transparent !important',
            display: 'block !important',
            width: '100% !important',
            height: '100% !important',
            padding: '0 !important',
            margin: '0 !important',
            zIndex: 'auto !important',
            '& .MuiBackdrop-root': {
              display: 'none !important',
            },
            '& > div[role="presentation"] > .MuiBox-root, & > .MuiPaper-root, & > .MuiBox-root': {
              boxShadow: 'none !important',
              border: 'none !important',
              background: 'transparent !important',
              margin: '0 !important',
              padding: '0 !important',
              width: '100% !important',
              height: 'auto !important',
              overflow: 'visible !important',
              position: 'static !important',
              display: 'block !important',

              '& .card-ap-detail': {
                position: 'static !important',
                transform: 'none !important',
                margin: '0 auto !important',
                width: '100% !important',
              },
            },
          },
          '.card-ap-detail': {
            position: 'unset',
            transform: 'none',
          },
        }}
      >
        <CardViewDetailBox />
      </Modal >



      <style>{
        size[0] > 1366 ? `` :
          `@media print {
        body > *:not(.MuiModal-root) { 
          display: none !important;
        }
        .no-print-section { 
          display: none !important;
        }
        .no-print {
          display: none !important;
        }
        #my-card-detail-to-hide { 
            display: none !important;
        }

        .no-page-break {
            page-break-inside: avoid !important;
            break-inside: avoid-page !important;
            -webkit-column-break-inside: avoid !important;
          }
      }
    `}</style>
    </>
  )
}


